export const logoTitleSizeStyle = '';
//# sourceMappingURL=logoTitleSizeStyle.js.map